import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { Payment } from '../members/Payment.js';
import { STInvoiceMeta } from './STInvoiceMeta.js';
export class STInvoice extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.payment = null;
        /**
         * If the number is null, no invoice is generated yet. Its still a WIP invoice (not an official one!)
         */
        this.number = null;
        this.createdAt = null;
        this.updatedAt = null;
        this.paidAt = null;
        this.negativeInvoiceId = null;
        this.didSendPeppol = false;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], STInvoice.prototype, "id", void 0);
__decorate([
    field({ decoder: Payment, nullable: true })
], STInvoice.prototype, "payment", void 0);
__decorate([
    field({ decoder: STInvoiceMeta })
], STInvoice.prototype, "meta", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], STInvoice.prototype, "number", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], STInvoice.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], STInvoice.prototype, "updatedAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], STInvoice.prototype, "paidAt", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 245 })
], STInvoice.prototype, "negativeInvoiceId", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], STInvoice.prototype, "didSendPeppol", void 0);
//# sourceMappingURL=STInvoice.js.map